// antd
import { Typography } from 'antd'

// styles
import tabStyles from '../profileTabContent.module.css'

function NoIndividualContent({ content }) {
    const { Title } = Typography

    return (
        <div className={tabStyles.emptyState}>
            <div className={tabStyles.emptyIcon}>{content?.icon}</div>
            <Title className={tabStyles.emptyTitle}>
                {`No ${content?.key} added`}
            </Title>
        </div>
    )
}

export default NoIndividualContent
